module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('small', [_vm._v("\n        © 2017 Alex van Vliet All Rights Reserved\n        "), _c('br'), _vm._v("\n        Credits : "), _c('a', {
    attrs: {
      "href": "https://www.behance.net/gallery/34290349/23XX-Free-Font"
    }
  }, [_vm._v("font")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ead0dc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 34
// module chunks = 1